<div class="px-15">
    <section id="overall-summaries" class="scrolld-parent">
        <div class="secction-header g-just-flex flex-between">
            <div class="words g-just-flex.flex-column.gap-12">
                <div class="title g-just-flex">
                    <div class="me-15">{{ isConsultant ? 'Consultant' : 'Doctor' }} Dashboard</div>
                </div>
                <div class="subtitle">
                    Real-time schedule and clinical tasks overview.
                </div>

              
            </div>

            <div class="controls g-just-flex gap-15" [scrolld]="'card'">
                <div class="rounded-icon-wrapper prev-btn">
                    <mat-icon>chevron_left</mat-icon>
                </div>
                <div class="rounded-icon-wrapper next-btn">
                    <mat-icon>chevron_right</mat-icon>
                </div>
            </div>
        </div>
@if (isConsultant) {
<div class="my-hospitals-row pt-15 g-just-flex gap-15">
    @if (isGlobalRemoteDoctor && currentHospitalName) {
      <div class="current-hospital-chip g-just-flex gap-8">
        <mat-icon>domain</mat-icon>
        <span>{{ currentHospitalName }}</span>
      </div>
    }
    <div class="action-button my-hospitals-btn" (click)="navigateToRemoteDoctorDashboard()">
        <div class="rounded-icon-wrapper">
            <mat-icon>local_hospital</mat-icon>
        </div>
        <span>My Hospitals</span>
        <mat-icon>chevron_right</mat-icon>
    </div>
</div>
}
        <div class="section-wrapper scrollable-container pt-30">
            <div class="overflow-container g-just-flex justify-content-start gap-30">
       
                <div class="card appointment-card" (click)="navigateToPatients()">
                    <div class="card-top g-just-flex space-between gap-30">
                        <div class="left g-just-flex gap-8 justify-content-start">
                            <div class="rounded-icon-wrapper">
                                <mat-icon>groups</mat-icon>
                            </div>
                            <div class="top-text subtitle-text-color-2">Current Patients</div>
                        </div>
                        <div class="right">
                            <mat-icon matTooltip="Patients with in-progress encounters assigned to you, excluding pharmacy visits. Click to open the patients list with the active-encounter filter applied.">light_bulb</mat-icon>
                        </div>
                    </div>
                    <div class="card-middle">
                        <div class="large-words">{{ (todaysPatients$ | async) || 0 }}</div>
                    </div>
                    <div class="card-bottom g-just-flex space-between gap-12">
                        <div class="left g-just-flex gap-10 subtitle-text-color-2 justify-content-start">
                            View active encounters
                        </div>
                    </div>
                </div>

                <div class="card appointment-card" (click)="navigateToPendingDiagnosis()">
                    <div class="card-top g-just-flex space-between gap-30">
                        <div class="left g-just-flex gap-8 justify-content-start">
                            <div class="rounded-icon-wrapper">
                                <mat-icon>fact_check</mat-icon>
                            </div>
                            <div class="top-text subtitle-text-color-2">Pending Diagnosis</div>
                        </div>
                        <div class="right">
                            <mat-icon matTooltip="Active non-pharmacy encounters assigned to you where no usable diagnosis references that encounter. Click to open the first patient's diagnosis tab for that exact encounter.">light_bulb</mat-icon>
                        </div>
                    </div>
                    <div class="card-middle">
                        <div class="large-words">{{ (pendingDiagnosis$ | async) || 0 }}</div>
                    </div>
                    <div class="card-bottom g-just-flex space-between gap-12">
                        <div class="left g-just-flex gap-10 subtitle-text-color-2 justify-content-start">
                            Add one diagnosis
                        </div>
                    </div>
                </div>

                @if(isConsultant){
                <div class="card appointment-card" (click)="navigateToAppointments()">
                    <div class="card-top g-just-flex space-between gap-30">
                        <div class="left g-just-flex gap-8 justify-content-start">
                            <div class="rounded-icon-wrapper">
                                <mat-icon>hail</mat-icon>
                            </div>
                            <div class="top-text subtitle-text-color-2">Consultations</div>
                        </div>
                        <div class="right">
                            <mat-icon matTooltip="Today's appointments with service category Consultation. Click to open the appointments page filtered to consultations.">light_bulb</mat-icon>
                        </div>
                    </div>
                    <div class="card-middle">
                        <div class="large-words">{{ (consultationAppointments$ | async) || 0 }}</div>
                    </div>
                    <div class="card-bottom g-just-flex space-between gap-12">
                        <div class="left g-just-flex gap-10 subtitle-text-color-2 justify-content-start">
                            Consultation appointments today
                        </div>
                    </div>
                </div>
                } @else {

                <div class="card appointment-card" (click)="navigateToAppointments()">
                    <div class="card-top g-just-flex space-between gap-30">
                        <div class="left g-just-flex gap-8 justify-content-start">
                            <div class="rounded-icon-wrapper">
                                <mat-icon>videocam</mat-icon>
                                <div class="grey round newbg">
                                    <mat-icon>auto_awesome</mat-icon>
                                </div>
                            </div>
                            <div class="top-text subtitle-text-color-2">Telemedicine</div>
                        </div>
                        <div class="right">
                            <mat-icon matTooltip="Today's appointments with service category Telemedicine. Click to open the appointments page filtered to telemedicine.">light_bulb</mat-icon>
                        </div>
                    </div>
                    <div class="card-middle">
                        <div class="large-words">{{ (telemedicineAppointments$ | async) || 0 }}</div>
                    </div>
                    <div class="card-bottom g-just-flex space-between gap-12">
                        <div class="left g-just-flex gap-10 subtitle-text-color-2 justify-content-start">
                            Remote appointments today
                        </div>
                    </div>
                </div>
                }
            </div>
        </div>
    </section>

    @if(!isConsultant){
    <div id="todays-activities" class="top-cards-section">
        <div class="top-cards-title py-10 ms-30">
            Today's Activities Summaries
        </div>
        @let summary = todaysActivitySummary$ | async;
        <div class="cards-wrapper">
            <div class="card">
                <div class="top">
                    <div class="title">
                        <div class="rounded-icon">
                            <mat-icon>ramp_right</mat-icon>
                        </div>
                        <div class="words">Outpatients</div>
                    </div>
                </div>
                <div class="bottom">
                    <div class="bottom-value">{{ summary?.outpatients || 0 }}</div>
                </div>
                <div class="igi-woroko">
                    <mat-icon>vaccines</mat-icon>
                </div>
            </div>

            <div class="card">
                <div class="top">
                    <div class="title">
                        <div class="rounded-icon">
                            <mat-icon>local_hotel</mat-icon>
                        </div>
                        <div class="words">Inpatients</div>
                    </div>
                </div>
                <div class="bottom">
                    <div class="bottom-value">{{ summary?.inpatients || 0 }}</div>
                </div>
                <div class="igi-woroko">
                    <mat-icon>vaccines</mat-icon>
                </div>
            </div>

            <div class="card">
                <div class="top">
                    <div class="title">
                        <div class="rounded-icon">
                            <mat-icon>video_call</mat-icon>
                        </div>
                        <div class="words">Virtual Encounters</div>
                    </div>
                </div>
                <div class="bottom">
                    <div class="bottom-value">{{ summary?.virtualEncounters || 0 }}</div>
                </div>
                <div class="igi-woroko">
                    <mat-icon>vaccines</mat-icon>
                </div>
            </div>

            <div class="card">
                <div class="top">
                    <div class="title">
                        <div class="rounded-icon">
                            <mat-icon>masks</mat-icon>
                        </div>
                        <div class="words">Surgeries</div>
                    </div>
                </div>
                <div class="bottom">
                    <div class="bottom-value">{{ summary?.surgeries || 0 }}</div>
                </div>
                <div class="igi-woroko">
                    <mat-icon>vaccines</mat-icon>
                </div>
            </div>
        </div>
    </div>
    }

    @if(isConsultant){
    <section id="next-consultant-appointments" class="scrolld-parent">
        <div class="secction-header g-just-flex flex-between">
            <div class="words g-just-flex.flex-column.gap-12">
                <div class="title">Next 3 Appointments</div>
            </div>
        </div>

        <div class="section-wrapper scrollable-container pt-20">
            <div class="overflow-container g-just-flex justify-content-start gap-30">
                @for(appointment of (nextAppointments$ | async) || []; track appointment.appointmentId) {
                <div class="card appointment-card next-appointment-card">
                    <div class="card-top g-just-flex space-between gap-30">
                        <div class="left g-just-flex gap-8 justify-content-start">
                            <div class="rounded-icon-wrapper"><mat-icon>event</mat-icon></div>
                            <div>
                                @if(appointment.patientReference){
                                <div class="top-text" [appReferenceDisplay]="appointment.patientReference" [instantFetchAndReplace]="true">
                                    {{ appointment.patientName }}
                                </div>
                                } @else {
                                <div class="top-text">{{ appointment.patientName }}</div>
                                }
                                <div class="subtitle-text-color-2">{{ appointment.appointmentType }}</div>
                            </div>
                        </div>
                    </div>
                    <div class="card-bottom g-just-flex gap-8 subtitle-text-color-2 justify-content-start">
                        <mat-icon>schedule</mat-icon>
                        <span>{{ appointment.start | date:'mediumDate' }} · {{ appointment.start | date:'shortTime' }} - {{ appointment.end | date:'shortTime' }}</span>
                    </div>
                </div>
                } @empty {
                <div class="subtitle-text-color-2">No upcoming appointments.</div>
                }
            </div>
        </div>
    </section>
    }

    <section id="next-dashboard-tasks" class="scrolld-parent">
        <div class="secction-header g-just-flex flex-between">
            <div class="words g-just-flex.flex-column.gap-12">
                <div class="title">Next 3 Tasks</div>
            </div>
        </div>

        <div class="section-wrapper scrollable-container pt-20">
            <div class="overflow-container g-just-flex justify-content-start gap-30">
                @for(task of (nextTasks$ | async) || []; track task.taskId) {
                <div class="card appointment-card" (click)="navigateToTasks()">
                    <div class="card-top g-just-flex space-between gap-30">
                        <div class="left g-just-flex gap-8 justify-content-start">
                            <div class="rounded-icon-wrapper"><mat-icon>task_alt</mat-icon></div>
                            <div>
                                <div class="top-text">{{ task.title }}</div>
                                @if(task.patientReference){
                                <div class="subtitle-text-color-2" [appReferenceDisplay]="task.patientReference" [instantFetchAndReplace]="true">
                                    {{ task.patientReference }}
                                </div>
                                }
                            </div>
                        </div>
                    </div>
                    <div class="card-bottom g-just-flex gap-8 subtitle-text-color-2 justify-content-start">
                        <mat-icon>schedule</mat-icon>
                        <span>{{ task.start | date:'short' }}</span>
                    </div>
                </div>
                } @empty {
                <div class="subtitle-text-color-2">No open tasks.</div>
                }
            </div>
        </div>
    </section>

    <section id="doctor-quick-actions" class="scrolld-parent">
        <div class="secction-header g-just-flex flex-between">
            <div class="words g-just-flex.flex-column.gap-12">
                <div class="title g-just-flex">
                    <div class="me-15">Quick Actions</div>
                </div>
            </div>

            <div class="controls g-just-flex gap-15" [scrolld]="'action-button'">
                <div class="rounded-icon-wrapper prev-btn">
                    <mat-icon>chevron_left</mat-icon>
                </div>
                <div class="rounded-icon-wrapper next-btn">
                    <mat-icon>chevron_right</mat-icon>
                </div>
            </div>
        </div>

        <div class="section-wrapper scrollable-container pt-30">
            <div class="overflow-container g-just-flex justify-content-start gap-30">
                <div class="action-button" (click)="navigateToAppointments()">
                    <div class="rounded-icon-wrapper">
                        <mat-icon>play_arrow</mat-icon>
                    </div>
                    <span>{{ isConsultant ? 'Open Consultations' : 'Open Telemedicine' }}</span>
                    <mat-icon>chevron_right</mat-icon>
                </div>

                <div class="action-button" (click)="navigateToPendingDiagnosis()">
                    <div class="rounded-icon-wrapper">
                        <mat-icon>fact_check</mat-icon>
                    </div>
                    <span>Pending Diagnosis</span>
                    <mat-icon>chevron_right</mat-icon>
                </div>

                <div class="action-button" (click)="navigateToPatients()">
                    <div class="rounded-icon-wrapper">
                        <mat-icon>groups</mat-icon>
                    </div>
                    <span>Current Patients</span>
                    <mat-icon>chevron_right</mat-icon>
                </div>
            </div>
        </div>
    </section>

    <section id="appointments-summaries" class="scrolld-parent">
        <div class="secction-header g-just-flex flex-between">
            <div class="words g-just-flex.flex-column.gap-12">
                <div class="title">Today's Schedule</div>
            </div>
        </div>

        <div class="section-wrapper pt-20">
              <app-upcoming-activities></app-upcoming-activities>
        </div>
    </section>
</div>
